import { useState, useMemo } from "react";
import { HelpCircle, Sparkles, Image, Video, Wand2, CreditCard, User, Shield } from "lucide-react";
import { useLanguage } from "@/contexts/LanguageContext";
import { HELP_FAQ_ITEMS } from "./constants";
import type { FAQItem, FAQCategory } from "./types";

export function useHelp() {
  const { t } = useLanguage();
  const [selectedCategory, setSelectedCategory] = useState("all");
  const [openItems, setOpenItems] = useState<number[]>([]);

  const helpCategories: FAQCategory[] = [
    { id: "all", label: t.help.catAll, icon: HelpCircle },
    { id: "getting-started", label: t.help.catGettingStarted, icon: Sparkles },
    { id: "images", label: t.help.catImages, icon: Image },
    { id: "videos", label: t.help.catVideos, icon: Video },
    { id: "editing", label: t.help.catEditing, icon: Wand2 },
    { id: "credits", label: t.help.catCredits, icon: CreditCard },
    { id: "account", label: t.help.catAccount, icon: User },
    { id: "technical", label: t.help.catTechnical, icon: Shield },
  ];

  const toggleItem = (index: number) => {
    setOpenItems(prev =>
      prev.includes(index)
        ? prev.filter(i => i !== index)
        : [...prev, index]
    );
  };

  const filteredFaqs = useMemo(() => {
    const faqs: FAQItem[] = HELP_FAQ_ITEMS.map(item => ({
      category: item.category,
      question: t.help[item.questionKey],
      answer: t.help[item.answerKey],
    }));
    return selectedCategory === "all"
      ? faqs
      : faqs.filter(faq => faq.category === selectedCategory);
  }, [t, selectedCategory]);

  return {
    selectedCategory,
    setSelectedCategory,
    openItems,
    toggleItem,
    filteredFaqs,
    helpCategories,
  };
}
